import {TokenCurrencyCode} from '@raison/types';
import {Action, combineReducers} from 'redux';
import {GenericAction} from '../types/common/GenericAction';
import {dynamicRateRoutine} from './dynamicRateActions';

export interface DynamicRateResponseItem {
    symbol: TokenCurrencyCode;
    placement_price: string;
    current_price: string;
    percent: string;
}

export interface DynamicRateItem {
    symbol: TokenCurrencyCode;
    percent: string;
}

const initialRate: DynamicRateItem[] = [];

function rates(state = initialRate, {type, payload}: GenericAction<DynamicRateResponseItem[]>) {
    switch (type) {
        case dynamicRateRoutine.SUCCESS:
            return payload.map(item => {
                const {symbol, percent, placement_price} = item;
                return {symbol, percent, placement_price};
            });
        default:
            return state;
    }
}

function fetching(state = false, {type}: Action) {
    switch (type) {
        case dynamicRateRoutine.SUCCESS:
        case dynamicRateRoutine.FAILURE:
            return false;
        case dynamicRateRoutine.TRIGGER:
            return true;
        default:
            return state;
    }
}

function failed(state = false, action: Action) {
    if (dynamicRateRoutine.failure.match(action)) {
        return true;
    }
    if (dynamicRateRoutine.trigger.match(action)) {
        return false;
    }
    return state;
}

export default combineReducers({
    rates,
    fetching,
    failed,
});
